<template>
  <div class="nav-menu-wrapper">
    <span class="iconbox" @click="openMsgCenter()">
      <i :class="['iconfont', 'icon-xiaoxi-line']"></i>
      <i v-if="msgBadge > 0" class="badge">{{ showBadge }}</i>
    </span>
    <template v-if="hasRTCPermi">
      <div
        :id="domId"
        class="draggable-wrapper"
        @mousedown="handleMouseDown"
        :style="dragStyleStr"
      >
        <el-popover
          class="rtc-panel"
          v-model="showRtcWeb"
          :width="iframeSize.width"
          :append-to-body="false"
          trigger="manual"
          placement="bottom-end"
        >
          <div>
            <div :class="['title', rtcBusy ? 'rtcBusy' : '']">
              <span class="left">{{ $t('home.videoCustomerService') }}</span>
              <div class="right">
                <span @click="openRtcHelpLink()">{{ $t('home.newUserGuide') }}</span>
                <i class="iconfont icon-guanbi-line" @click="openRtcWeb()"></i>
              </div>
            </div>
            <iframe ref="rtcFrame" :src="rtcLink" allow="camera;microphone" allowfullscreen="allowfullscreen" width="100%" :style="{height:iframeSize.height+'px'}"></iframe>
            <!-- <iframe
              src="http://127.0.0.1:3003/call"
              allow="camera;microphone"
              allowfullscreen="allowfullscreen"
              width="100%"
              :style="{ height: iframeSize.height + 'px' }"
            ></iframe> -->
          </div>
        </el-popover>
      </div>

      <span class="iconbox" @click="openRtcWeb()" slot="reference">
        <i :class="['iconfont', 'icon-shipin-line']"></i>
        <i class="badge bottom" :style="{ 'background-color': rtcColor }"></i>
      </span>
    </template>

    <span
      class="iconbox"
      v-for="(item, index) in noCollapsedMenu"
      :key="index"
      :title="item.name"
      @click="menuClick(item)"
    >
      <i :class="['iconfont', item.icon]"></i>
    </span>
    <!-- 下拉模式 -->
    <span class="header-menu-warp iconbox" v-if="collapsedMenu.length > 0">
      <el-dropdown trigger="click" @command="menuClick">
        <div class="el-dropdown-link">
          <i class="iconfont icon-gengduo-line"></i>
        </div>
        <el-dropdown-menu slot="dropdown" class="el-dropdown-menu-box">
          <el-dropdown-item
            v-for="item in collapsedMenu"
            :key="item.id"
            :command="item"
          >
            <i :class="['iconfont', item.icon]"></i>{{ item.name }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </span>
    <el-dropdown v-if="showLanguageDropdown" @command="handleCommandLanguage" class="language-dropdown">
      <span class="iconbox">
        <i :class="['iconfont', 'icon-duoyuyan-line']" style="color: #fff;"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="language in languageMap" :command="language">
          <span :class="`${language.code === currLanguage?'language-active':''}`">{{ language.name }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import _ from 'lodash'
import { getUnReadMsgCount, checkRTCPermission } from "@/api/index";
import { cookie, hmt_statistic } from "@/utils";
import { setI18nCookie } from '@/i18n'
const COLOR_RTC = {
  offline: "#B4B5B8",
  online: "#34CB82",
  error: "#FF4D4F",
  offline: "#B4B5B8",
  incall: "#0090FF",
  outcall: "#0090FF",
  duringcall: "#0090FF",
};
export default {
  name: "nav-menu",
  props: {
    navMenu: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  created() {
    // 初始化防抖版本的 getUnreadMsgCount
    this.debounceGetUnreadMsgCount = _.debounce(() => {
      console.log(1111111, 'debounceGetUnreadMsgCount')
      getUnReadMsgCount()
        .then((res) => {
          const { code = 0, data: { count = 0 } = {}, message } = res;
          if (code == 0) {
            this.msgBadge = count;
          } else {
            console.log("查询未读消息数异常", code, message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, 600);
  },
  mounted() {
    this.handleCommandLanguage()
    this.checkRTCPermi();
    this._Bus.$on("updateAppConfig", () => {
      this.checkRTCPermi();
    });

    window.addEventListener("message", this.postMsgListener);
    this.debounceGetUnreadMsgCount();
    this._Bus.$on("updateUnReadMsgCount", (tab) => {
      this.debounceGetUnreadMsgCount();
    });
    if(location.href.includes('localhost') || location.href.includes('test') || true){
      this.showLanguageDropdown = true
    }

    // 控制台控制语言下拉框显示/隐藏
    window.__toggleLanguageDropdown__ = (visible) => {
      if (typeof visible === 'boolean') {
        this.showLanguageDropdown = visible;
      } else {
        this.showLanguageDropdown = !this.showLanguageDropdown;
      }
      console.log('[i18n] language dropdown visible:', this.showLanguageDropdown);
    };
    console.log('[i18n] 输入 __toggleLanguageDropdown__() 切换语言下拉框显示');
  },
  beforeDestroy() {
    window.removeEventListener("message", this.postMsgListener);
    delete window.__toggleLanguageDropdown__;

    // 清理防抖定时器
    if (this.debounceGetUnreadMsgCount) {
      this.debounceGetUnreadMsgCount.cancel();
      this.debounceGetUnreadMsgCount = null;
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    rtcColor() {
      return COLOR_RTC[this.rtc_ag_status];
    },
    rtcBusy() {
      let rtc_ag_status = this.rtc_ag_status;
      return ["incall", "outcall", "duringcall"].includes(rtc_ag_status);
    },
    showBadge() {
      return this.msgBadge > 99 ? "99+" : this.msgBadge;
    },
    /**
     * 功能：根据navMenu过滤直显菜单
     */
    noCollapsedMenu() {
      return this.navMenu.filter((menu) => {
        if(!menu.collapsed){
          // 如果是知识库，需要判断权限，power_zsk_view
          if(menu.name == this.$t('home.knowledgeBase') || menu.name == '知识库' ){
            let roleActionList = this.userInfo.roleActionList || ''

            if(this.userInfo.vcc.isEnableKmsV3==1 && menu.onclick.v3Url){
              menu.onclick.url = menu.onclick.v3Url
              menu.onclick.width = 600
            }

            if(roleActionList == 'all' || roleActionList.includes('power_zsk_view')){
              return true
            }else{
              return false
            }
          }

          return true
        }
        return false
      });
    },
    /**
     * 功能：根据navMenu过滤，收起下拉菜单
     */
    collapsedMenu() {
      return this.navMenu.filter((menu) => menu.collapsed);
    },
  },
  data() {
    return {
      msgBadge: 0,

      hasRTCPermi: false,
      rtcLink: "",
      showRtcWeb: false,
      rtc_ag_status: "offline",
      iframeSize: {
        width: 360,
        height: 446,
      },
      dragStyleStr: '',
      dragMes: {},
      domId: 'draggable',

      currLanguage: '',
      showLanguageDropdown: false,
      languageMap: [
        {code: 'zh-CN', name: '简体中文'},
        {code: 'en-US', name: 'English'},
      ],

      // 防抖版本的获取未读消息数
      debounceGetUnreadMsgCount: null
    };
  },
  methods: {
    ...mapActions(["changeDrawerInfo", "addTab"]),
    handleCommandLanguage(language){
      const i18nextLng = cookie.getCookie("i18nextLng") || ''

      if(language){
        this.currLanguage = language.code
      }else{
        this.currLanguage = i18nextLng || 'zh-CN'
      }

      setI18nCookie(this.currLanguage)

      if(language && i18nextLng != this.currLanguage){
        window.location.reload()
      }
    },

    handleMouseDown(e) {
      if(!this.rtcBusy){
        return false;
      }
      const oBox = document.getElementById(this.domId);
      this.dragMes.disX = e.clientX - oBox.offsetLeft;
      this.dragMes.disY = e.clientY - oBox.offsetTop;
      document.onmousemove = e => {
        let left = e.clientX - this.dragMes.disX + 'px';
        let top = e.clientY - this.dragMes.disY + 'px';
        this.dragStyleStr = `left: ${left};top: ${top}`;
      };
      document.onmouseup = () => {
        document.onmousemove = document.onmouseup = null;
      };
      e.preventDefault();
    },
    checkRTCPermi() {
      const { video: { video = "" } = {} } = this._config.URL;
      if (video) {
        this.rtcLink = video + "/call";
        checkRTCPermission(video).then((resp) => {
          if (resp.code == "200") {
            this.hasRTCPermi = true;
          }
        },()=>{

        });
      }
    },
    menuClick(menuInfo) {
      hmt_statistic(location.href,`导航栏-${menuInfo.name}`)
      this.$emit("menuClick", menuInfo);
    },
    openRtcWeb() {
      if(!this.showRtcWeb){
        hmt_statistic(location.href,'导航栏-视频客服')
      }
      this.showRtcWeb = !this.showRtcWeb;
    },
    openRtcHelpLink() {
      window.open(
        "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/EpGBa2Lm8azLRRELf3xy3YeaWgN7R35y"
      );
    },
    getUnreadMsgCount() {
      getUnReadMsgCount()
        .then((res) => {
          const { code = 0, data: { count = 0 } = {}, message } = res;
          if (code == 0) {
            this.msgBadge = count;
          } else {
            console.log(this.$t('home.queryUnreadMsgError'), code, message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openMsgCenter() {
      const { my: { ekt_common = "" } = {} } = this._config.URL || {};
      hmt_statistic(location.href,'导航栏-消息')
      if (ekt_common) {
        let addTabItem = {
          key: this.$t('home.msgCenter'),
          name: this.$t('home.msgCenter'),
          url: `${ekt_common}/messageCenter/message`,
        };

        this.addTab(addTabItem);
      }
    },

    /**
     * 0、接收postMessage传递过来的消息
     *  e.data 有两种格式：json字符串(来自己manage)和对象(ekt)
     * */
    postMsgListener(e) {
      let POST_TYPE = this._config.POST_MSG_TYPE;

      const { origin, data: postMsg = "" } = e;
      let msgData = null;

      if (["", "unchanged", "changed"].includes(postMsg)) {
        return;
      }
      // 开发调试器
      if (
        (postMsg.source && postMsg.source.includes("vue-devtools")) ||
        postMsg.hasOwnProperty("vueDetected")
      ) {
        return;
      }

      try {
        msgData = typeof postMsg == "string" ? JSON.parse(postMsg) : postMsg;
      } catch (error) {
        console.log("error:" + error + ", postMsgData:" + postMsg);
        return;
      }

      let type = (msgData.type || 0) + "";

      switch (type) {
        case POST_TYPE.TRC_WEB_CHANGE_SIZE:
          {
            const { trc_ag_status: trcAgAtatus, width, height } = msgData;
            if (!this.hasRTCPermi) return;

            // 通话结束：关闭面板、重置面板位置
            if (
              (this.rtc_ag_status == "duringcall" ||
                this.rtc_ag_status == "incall" ||
                this.rtc_ag_status == "outcall") &&
              trcAgAtatus != "duringcall"
            ) {
              this.showRtcWeb = false;
              this.dragStyleStr = ''
            }

            this.iframeSize.width = width;
            this.iframeSize.height = height;
            this.rtc_ag_status = trcAgAtatus;
            if (trcAgAtatus == "incall" || trcAgAtatus == "outcall") {
              this.showRtcWeb = true;
              this.dragStyleStr = 'left: calc(50vw + 360px);top: calc(50vh - 265px);'
            }
          }

          break;
        case POST_TYPE.OPEN_RTC_PANEL:
          if (!this.hasRTCPermi) return;
          let trc_ag_status = cookie.getCookie("trc_ag_status") || "offline";
          if (["offline", "error"].includes(trc_ag_status)) {
            this.showRtcWeb = true;
          }
          break;

        case POST_TYPE.MAKE_RTC_CALL:
          console.log('rtcFrame MAKE_RTC_CALL')
          if (this.$refs.rtcFrame) {
            console.log('rtcFrame postmessage',msgData)
            let iframeWin = this.$refs.rtcFrame.contentWindow;  //获取这个属性
            iframeWin.postMessage(msgData, "*");   //发送数据
          }
          break;

        default:
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>
<style>
.rtc-panel .el-popover {
  padding: 0 !important;
  right: -80px;
  border-radius: 16px;
  overflow: hidden;
}

.language-active{
  color: #0090FF;
}
</style>



// WEBPACK FOOTER //
// src/view/Home/header/navMenu/index.vue